/* cji-gallery-track, 10 September 2026.

   Jamie: "I don't know what exactly in the images are they looking for that
   will entice them to buy it." Nobody did. The gallery was the one thing on
   this site with no instrumentation, and Clarity says product pages get 23%
   average scroll depth and 16 seconds of active time, so for most visitors the
   gallery IS the page.

   It measures BEHAVIOUR, not people. Product handle, how deep into the photos
   they got, how long each one held them, whether they opened the lightbox,
   whether the buy button ever came into view, and how far down they reached.
   No identifier, no cursor track. Clarity already records sessions and this is
   not a second copy of it.

   It must never cost the shopper anything, so: one sendBeacon on the way out,
   IntersectionObserver rather than a scroll handler, and every line wrapped so
   a fault here cannot touch the buy button. If anything throws, the shopper
   gets a working product page and we get no row, which is the right way round.

   The gallery is the Xtra theme's ul.l4pr, a horizontal scroller of li items,
   each holding an a[data-fancybox] that opens the lightbox. */
(function () {
  'use strict';
  try {
    if (!/\/products\//.test(location.pathname)) return;
    if (window.__cjiGalTrack) return;
    window.__cjiGalTrack = 1;

    /* Crawlers, not shoppers. The first day recorded 64 rows and every one was
       width 1920, scroll depth 94 to 100%, zero zooms, and never past photo 1:
       load the page, scroll to the bottom, leave. Clarity says 95% of sessions
       on this site are bots, so that is what the beacon was measuring.

       A programmatic scroll fires a scroll event but it does NOT fire
       pointerdown, touchstart, keydown or wheel. Requiring one real input
       gesture before sending is therefore a good discriminator, and it costs a
       genuine shopper nothing: any scroll on a phone is a touch and any scroll
       on a desktop is a wheel. Somebody who lands, reads without touching
       anything and leaves is dropped, and they carried no gallery signal
       anyway. navigator.webdriver catches the honest automation on the way in. */
    if (navigator.webdriver) return;
    var API = 'https://api.classiquejewelryinc.com/gallery';
    var handle = (location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];
    if (!handle) return;

    var ul = document.querySelector('ul.l4pr');
    var slides = ul ? [].slice.call(ul.children) : [];
    var n = slides.length;

    var deepest = 0, zooms = 0, sawBuy = 0, scrollPct = 0, interacted = 0;
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
      window.addEventListener(ev, function () { interacted = 1; },
                              { passive: true, once: true });
    });
    var seen = {}, dwell = {}, current = -1, since = 0, firstMove = 0;
    var start = Date.now(), activeMs = 0, lastTick = Date.now(), hidden = false;

    /* Active time only. A tab left open behind another one is not a shopper
       looking at a photo, and counting it would make every number meaningless. */
    setInterval(function () {
      var now = Date.now();
      if (!hidden && now - lastTick < 4000) activeMs += now - lastTick;
      lastTick = now;
    }, 1000);
    document.addEventListener('visibilitychange', function () {
      hidden = document.hidden;
      if (hidden) closeCurrent();
    });

    function closeCurrent() {
      if (current >= 0 && since) {
        dwell[current] = (dwell[current] || 0) + (Date.now() - since);
      }
      since = 0;
    }

    if (n > 1 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) {
            best = e;
          }
        });
        if (!best) return;
        var idx = slides.indexOf(best.target);
        if (idx < 0 || idx === current) return;
        closeCurrent();
        current = idx;
        since = Date.now();
        seen[idx] = 1;
        if (idx > deepest) deepest = idx;
        /* How long before they moved off the first photo at all. A page where
           nobody ever reaches image 2 is a different problem from one where
           they flick through all six and leave. */
        if (idx > 0 && !firstMove) firstMove = Date.now() - start;
      }, { threshold: [0.5, 0.9] });
      slides.forEach(function (li) { io.observe(li); });
    } else if (n) {
      seen[0] = 1; current = 0; since = Date.now();
    }

    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest && ev.target.closest('a[data-fancybox]');
      if (a) zooms++;
    }, true);

    /* The theme's button says Add to Bag, not Add to Cart, and carries none of
       the three selectors this first reached for, so saw_buy read 0 on every
       row for a day. Checked against the rendered page: the real one is a
       submit button inside form[action="/cart/add"], class overlay-buy_button.
       The other names stay as a fallback for the personalizer templates. */
    var buy = document.querySelector(
      'form[action*="/cart/add"] button[type="submit"], .overlay-buy_button, ' +
      'button[name="add"], .product-form__submit, [data-add-to-cart]');
    if (buy && 'IntersectionObserver' in window) {
      var bio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sawBuy = 1; bio.disconnect(); } });
      });
      bio.observe(buy);
    }

    /* Scroll depth from a passive listener, throttled by rAF, so it cannot
       become the thing that makes the page feel heavy. */
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0) {
          var p = Math.round(((window.scrollY || 0) / h) * 100);
          if (p > scrollPct) scrollPct = Math.min(100, p);
        }
      });
    }, { passive: true });

    var sent = false;
    function send() {
      if (sent) return;
      /* No gesture, no row. Silence is the right answer for a crawler: a row
         marked as a bot still has to be remembered and excluded by every reader
         of this table forever. */
      if (!interacted) return;
      sent = true;
      try {
        closeCurrent();
        var total = 0, viewed = 0, k;
        for (k in dwell) { total += dwell[k]; }
        for (k in seen) { viewed++; }
        var body = JSON.stringify({
          handle: handle, images: n, deepest: deepest, viewed: viewed,
          dwell_ms: total, first_ms: firstMove, zooms: zooms,
          saw_buy: sawBuy, scroll_pct: scrollPct, active_ms: activeMs,
          width: window.innerWidth || 0, interacted: interacted
        });
        if (navigator.sendBeacon) {
          navigator.sendBeacon(API, new Blob([body], { type: 'application/json' }));
        }
      } catch (e) { /* a beacon is never worth an error on a product page */ }
    }
    /* pagehide fires on the bfcache path where unload does not, and
       visibilitychange hidden is the only one iOS reliably gives. Both, once. */
    window.addEventListener('pagehide', send);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) send();
    });
  } catch (e) { /* never break the page */ }
})();
